import { render } from "./RequiredAttachment.vue?vue&type=template&id=f7c5ab64"
import script from "./RequiredAttachment.vue?vue&type=script&lang=js"
export * from "./RequiredAttachment.vue?vue&type=script&lang=js"

import "./RequiredAttachment.vue?vue&type=style&index=0&id=f7c5ab64&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__